import { render } from "./animauxVue.vue?vue&type=template&id=0c1432e8"
import script from "./animauxVue.vue?vue&type=script&lang=js"
export * from "./animauxVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__